import React from 'react';
import PropTypes from 'prop-types';
import I18nStore from 'stores/I18nStore';
import I18nActionCreator from 'actions/I18nActionCreator';
import ActivitySpinner from 'components/shared/ActivitySpinner';
import ClientSideMetrics from 'utils/ClientSideMetrics';
/**
 * See http://survivejs.com/webpack_react/understanding_decorators/
 */
const provideTranslations = (
  Component,
  key,
) => class ConnectToTranslations extends React.Component {
    static propTypes = {
      location: PropTypes.object,
    };

    static childContextTypes = {
      getString: PropTypes.func,
    };

    static contextTypes = {
      router: PropTypes.object.isRequired,
    };

    constructor(props) {
      super(props);
      this.onChange = this.onChange.bind(this);
    }

    getChildContext() {
      return {
        getString(stringId, replacements) {
          const state = I18nStore.getState();
          let string = state.strings[stringId];
          if (string) {
            if (replacements !== undefined) {
              Object.entries(replacements).forEach(([replaceId, value]) => {
                const reg = new RegExp(`\\$\\{${replaceId}\\}`, 'g');
                string = string.replace(reg, value);
              });
            }
            return string;
          }
          /* String wasn't found, we need to log and return something so
          methods that are called on the strings don't crash the app */
          ClientSideMetrics.log(`String "${stringId}" was not found`);
          if (process.env.NODE_ENV === 'production') {
            return '';
          }
          return 'STRING_TRANSLATION_NOT_FOUND';
        },
      };
    }

    componentDidMount() {
      I18nStore.listen(this.onChange);
      const state = I18nStore.getState();
      if (!state.assets.includes(key)) {
        const locale = state.currentLocale || 'en_US';
        I18nActionCreator.fetch(locale, key);
      }
    }

    componentWillUnmount() {
      I18nStore.unlisten(this.onChange);
    }

    onChange() {
      const state = I18nStore.getState();
      if (state.currentLocale && !state.isLoading && state.assets.length === 0) {
        this.refreshWithNewLocale(state.currentLocale);
      } else {
        /*
        * We use force update instead of setState to re-render subcomponents.
        * Given the fact we pass the objects as a context and not props it's ok
        * to bypass the componentShouldUpdate lifecycle method. There is a known limitation
        * with context and componentShouldUpdate. See documentation below.
        * https://facebook.github.io/react/docs/component-api.html -- see forceUpdate
        * https://facebook.github.io/react/docs/context.html -- see context.
        */
        this.forceUpdate();
      }
    }

    // The top level provideTranslations should have location as a prop
    refreshWithNewLocale(newLocale) {
      const { location } = this.props;
      const { router } = this.context;
      if (location) {
        const newQuery = Object.assign(location.query, { locale: newLocale });
        router.replace({ pathname: location.pathname, query: newQuery });
        window.location.reload();
      }
    }

    render() {
      const loading = !I18nStore.getState().assets.includes(key) && !I18nStore.getState().error;
      return loading ? <ActivitySpinner className="absolute-center" /> : <Component {...this.props} {...this.state} />;
    }
};

export default key => target => provideTranslations(target, key.toLowerCase());
